import useAuthToken, { TokenInformation } from "core/hooks/useAuthToken";
import { ReactNode, createContext, useContext } from "react";



const UserContext = createContext<TokenInformation | null>(null);

export interface UserProviderProps {
    children: ReactNode;
}

export const UserProvider = ({ children }: UserProviderProps) => {
    const user = useAuthToken();

    return (
        <UserContext.Provider value={user} >
            {children}
        </ UserContext.Provider>
    );
}

export const useUserContext = () => useContext(UserContext);
